// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-fotowoltaika-dla-domu-js": function componentSrcPagesFotowoltaikaDlaDomuJs() {
    return import("./../../src/pages/fotowoltaika-dla-domu.js"
    /* webpackChunkName: "component---src-pages-fotowoltaika-dla-domu-js" */
    );
  },
  "component---src-pages-fotowoltaika-dla-firm-js": function componentSrcPagesFotowoltaikaDlaFirmJs() {
    return import("./../../src/pages/fotowoltaika-dla-firm.js"
    /* webpackChunkName: "component---src-pages-fotowoltaika-dla-firm-js" */
    );
  },
  "component---src-pages-iluminacje-swiateczne-js": function componentSrcPagesIluminacjeSwiateczneJs() {
    return import("./../../src/pages/iluminacje-swiateczne.js"
    /* webpackChunkName: "component---src-pages-iluminacje-swiateczne-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-o-nas-js": function componentSrcPagesONasJs() {
    return import("./../../src/pages/o-nas.js"
    /* webpackChunkName: "component---src-pages-o-nas-js" */
    );
  },
  "component---src-pages-oswietlenie-przemyslowe-led-js": function componentSrcPagesOswietleniePrzemysloweLedJs() {
    return import("./../../src/pages/oswietlenie-przemyslowe-led.js"
    /* webpackChunkName: "component---src-pages-oswietlenie-przemyslowe-led-js" */
    );
  },
  "component---src-pages-projekty-instalacji-elektrycznej-w-domu-js": function componentSrcPagesProjektyInstalacjiElektrycznejWDomuJs() {
    return import("./../../src/pages/projekty-instalacji-elektrycznej-w-domu.js"
    /* webpackChunkName: "component---src-pages-projekty-instalacji-elektrycznej-w-domu-js" */
    );
  },
  "component---src-pages-projekty-instalacji-elektrycznej-w-przemysle-js": function componentSrcPagesProjektyInstalacjiElektrycznejWPrzemysleJs() {
    return import("./../../src/pages/projekty-instalacji-elektrycznej-w-przemysle.js"
    /* webpackChunkName: "component---src-pages-projekty-instalacji-elektrycznej-w-przemysle-js" */
    );
  }
};